import { Box, Chip, Typography } from '@mui/material';
import type { Label } from '@vy/types';
import type { FC } from 'react';
import { ColorDot } from '../../../design/ColorDot';

type LabelsChipsProps = {
  labels: Label[];
};

export const LabelsChips: FC<LabelsChipsProps> = ({ labels }) => {
  if (labels.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          cursor: 'pointer',
          fontSize: 14,
          '&:hover': {
            color: 'primary.main',
          },
        }}
      >
        + Add label
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      {labels.map((label) => (
        <Chip
          key={label.id}
          size="small"
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
              <ColorDot color={label.color} sizeOverride="8px" />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {label.name}
              </span>
            </Box>
          }
          sx={{
            backgroundColor: 'common.white',
            border: '1px solid',
            borderColor: 'divider',
            color: 'text.primary',
            height: 32,
            borderRadius: '16px',
            '& .MuiChip-label': {
              px: 1.5,
            },
            cursor: 'pointer',
            maxWidth: 200,
            '&:hover': {
              backgroundColor: 'background.default',
            },
          }}
        />
      ))}
    </Box>
  );
};
